'use client';

import { cn } from '@/app/lib';
import { SearchBox, SearchBoxProps } from 'react-instantsearch';
import { Icon } from '@workspace/ui/common';

export function SearchBoxSubmitIcon(props: { classNames: { submitIcon?: string } }) {
  return (
    <Icon
      name="SearchFilter"
      className={cn('ais-SearchBox-submitIcon text-secondary-400', props.classNames.submitIcon)}
    />
  );
}

type AlgoliaSearchBoxProps = SearchBoxProps & {
  containerClassName?: string;
  fullWidth?: boolean;
};

/**
 * Algolia Search Box component Styled according to SearchBar components
 */
export function AlgoliaSearchBox({ containerClassName, fullWidth = false, ...props }: AlgoliaSearchBoxProps) {
  return (
    <div className={cn('relative', fullWidth ? 'w-full' : 'max-w-122', containerClassName)}>
      <SearchBox
        classNames={{
          root: 'w-full',
          form: 'w-full',
          input:
            'border border-secondary-100 font-body placeholder:text-base placeholder:font-normal placeholder:text-secondary-500 text-secondary-900 rounded-sm px-3 py-2 w-full pr-10 h-12 border-secondary-100 primary-focus',
          loadingIndicator: 'hidden',
          reset: 'hidden',
          submit:
            'absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center justify-center cursor-pointer size-6',
        }}
        submitIconComponent={SearchBoxSubmitIcon}
        {...props}
      />
    </div>
  );
}
